import { render } from "./AdsetBudgetBlock.vue?vue&type=template&id=2bb2f83a"
import script from "./AdsetBudgetBlock.vue?vue&type=script&lang=js"
export * from "./AdsetBudgetBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/AdsetBudgetBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bb2f83a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bb2f83a', __exports__)) {
    api.reload('2bb2f83a', __exports__)
  }
  
  module.hot.accept("./AdsetBudgetBlock.vue?vue&type=template&id=2bb2f83a", () => {
    api.rerender('2bb2f83a', render)
  })

}


export default __exports__